import { useTypedSelector } from '../../reducers';
import EditScheduleView from './shared/EditScheduleView';
import { useUserStatusContext } from '../../contexts/UserStatusContext';
import { ScreenError } from '../../components';

export default function MyEditScheduleScreen() {
  const clinicianId = useTypedSelector((s) => s.auth.user?.id);
  const { myClinicianStatus } = useUserStatusContext();

  if (!clinicianId) return null;

  const clinicianProfile = myClinicianStatus.user.clinicianProfile;
  if (!clinicianProfile)
    return <ScreenError error={new Error('Clinician has no profile.')} />;

  return (
    <EditScheduleView
      clinicianId={clinicianId}
      durationMinutes={clinicianProfile.appointmentDuration}
      bufferMinutes={clinicianProfile.appointmentBuffer}
    />
  );
}
